import { render } from "./LanguageSelectionMenu.vue?vue&type=template&id=3b95b56c"
import script from "./LanguageSelectionMenu.vue?vue&type=script&lang=js"
export * from "./LanguageSelectionMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__